import { db } from "@/firebase";
import Vue from "vue"

export const EventBus = new Vue()

export default {
  getEmergencyMsg: function () {
    db.ref("emergency_message").on("value", (snapshot) => {
      const valor = snapshot.val() || "";
      EventBus.$emit("eventBusEmergencyMsg", valor);
    });
  },
  setEmergencyMsg(nuevoValor) {
    return db.ref("emergency_message").set(nuevoValor);
  },
};
